module.exports = __webpack_public_path__ + "static/media/tasks-blue.43c898d6.svg";